<template>
  <div class="container product-listing__wrap">
    <div class="row product-listing__row">
      <div class="col-md-3 product-listing__col product-listing__sidebar js-sidebar-wrap">
        <BlockProductSidebar
            v-if="products" :productType="products.productsType"
            :productCollections="products.productCollections"
            :productStyle="products.productStyle"
            :productBrand="products.productBrand"
            :productMaterial="products.productMaterial"
            :productSize="products.productSize"
            :productWidth="products.productWidth"
            :productLength="products.productLength"
            :productHeight="products.productHeight"
            :productDepth="products.productDepth"
            :productTypesAttr="products.productTypesAttr"
            :products="sapData.products"
        />
      </div>

      <div class="col-md-9 product-listing__main product-listing__col js-product-listing">
        <BlockProductListing
            v-if="products" :products="sapData.productsRow"
            :pagination="sapData.pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlockProductListing from '@/vue/components/blocks/BlockProductListing.vue';
import BlockProductSidebar from '@/vue/components/blocks/BlockProductSidebar.vue';
import {EventBus} from '@/vue/store';
import Global from '../../js/_site/global';

export default {
  beforeMount() {
    this.setCookieFilters();
  },
  components: {
    BlockProductListing,
    BlockProductSidebar
  },
  computed: {
    // step 5 get products from state
    products() {
      return this.sapData;
    },
  },
  methods: {
    setCookieFilters() {
      Global.setCookie('filters', location.search.substring(1));
    }
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      sapData: sapData,
    };
  },
};
</script>

<style lang="scss" scoped>
.product-listing__row {
  margin: 0 -5px;
}

.product-listing__col {
  padding: 0 5px;
}

.single-collection {
  .product-listing__main {
    margin-top: -17px;

    @include mq($md) {
      margin-top: 0;
    }
  }
}

.product-listing__main {
  // margin-top: -85px;
  margin-top: -17px;
  min-height: 1300px;

  @include mq($md) {
    margin-top: 0;
    min-height: 100px;
  }
}

.product-listing__sidebar {
  @include mq($md) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    max-width: 300px;
    z-index: 15;
    background-color: $white;
    padding-top: 60px;
    transform: translateX(-100%);
    transition: 0.3s ease-in-out;
  }

  @include mq(350px) {
    max-width: 100%;
  }
}

.opened-sidebar {
  transform: translateX(0);
  transition: 0.3s ease-in-out;
  box-shadow: 0 10px 50px 5px rgba($black, .1)
}
</style>
